module.exports = __webpack_public_path__ + "static/media/REMAN-SLIDE-4.6dbbaec4.png";